import React from "react";

const EmptyStatementMsg = (props) => {
  return (
    <div className="empty-statement flex justify-center flex-grow">
      <div className="flex justify-center flex-grow">{props.message}</div>
    </div>
  );
};

export default EmptyStatementMsg;
